import { Outlet, Link } from "react-router-dom";

import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavLink from "react-bootstrap/NavLink";
import NavbarBrand from "react-bootstrap/NavbarBrand";
import NavbarToggle from "react-bootstrap/NavbarToggle";
import NavbarOffcanvas from "react-bootstrap/NavbarOffcanvas";
import OffcanvasHeader from "react-bootstrap/OffcanvasHeader";


import 'bootstrap/dist/css/bootstrap.css';

const Layout = () => {
    return (
        <>
			<Navbar expand="true" sticky="top" className="p-3 bg-body-secondary">
				<NavbarBrand href="/">Roman Seas Companion App</NavbarBrand>
				<NavbarToggle />
				<NavbarOffcanvas placement="start" className="d-sm-none ps-3 bg-body-secondary">
					<OffcanvasHeader closeButton />
					<Nav>
						<NavLink href="/grappling-ungrappling">Grappling/Ungrappling</NavLink>
						<NavLink href="/crew-tiring">Crew Tiring</NavLink>
						<NavLink href="/running-aground">Running Aground</NavLink>
						<NavLink href="/ramming-and-oar-rake-attacks">Ramming & Oar Rake Attacks</NavLink>
						<NavLink href="/mast-damage">Mast Damage</NavLink>
						<NavLink href="/fouling">Fouling</NavLink>
						<NavLink href="/missile-attacks">Missile Attacks</NavLink>
						<NavLink href="/artillery-hits-on-ships">Artillery Hits on Ships</NavLink>
						<NavLink href="/fire-attacks">Fire Attacks</NavLink>
						<NavLink href="/close-combat">Close Combat</NavLink>
					</Nav>
				</NavbarOffcanvas>
				<NavbarOffcanvas placement="end" className="d-none d-sm-block ps-3 bg-body-secondary">
					<OffcanvasHeader closeButton />
					<Nav>
						<NavLink href="/grappling-ungrappling">Grappling/Ungrappling</NavLink>
						<NavLink href="/crew-tiring">Crew Tiring</NavLink>
						<NavLink href="/running-aground">Running Aground</NavLink>
						<NavLink href="/ramming-and-oar-rake-attacks">Ramming & Oar Rake Attacks</NavLink>
						<NavLink href="/mast-damage">Mast Damage</NavLink>
						<NavLink href="/fouling">Fouling</NavLink>
						<NavLink href="/missile-attacks">Missile Attacks</NavLink>
						<NavLink href="/artillery-hits-on-ships">Artillery Hits on Ships</NavLink>
						<NavLink href="/fire-attacks">Fire Attacks</NavLink>
						<NavLink href="/close-combat">Close Combat</NavLink>
					</Nav>
				</NavbarOffcanvas>
			</Navbar>
			<Container fluid className="p-3">
	            <Outlet />
			</Container>
        </>
    )
};

export default Layout;